import type { IconName } from "@/components/Icon";

export const TABS: readonly { path: string; title: string; icon: IconName }[] = [
  { path: "/", title: "Calculator", icon: "calculator" },
  { path: "/compare", title: "Compare", icon: "compare" },
  { path: "/saved", title: "Saved", icon: "bookmark" },
  { path: "/settings", title: "Settings", icon: "settings" },
];
